import { observer } from "mobx-react-lite";
import i from "../../../../translations/i";
import { Titles } from "../../../../layouts/Titles";
import React, { useEffect } from "react";
import ModifiersController from "../usecase/modifiers.controller";
import { Button, Popconfirm, Space, Table, Tag, Tooltip } from "antd";
import { DeleteOutlined, SettingOutlined } from "@ant-design/icons";
import { canManageOwnedRecord } from "../../../../helpers/manager_ownership";

export const Modifiers = observer(() => {

  useEffect(() => {
    ModifiersController.GetModifiers()
  }, [])

  const columns = [
    {
      title: "ID",
      dataIndex: 'id',
      key: 'id'
    },
    {
      title: i.t('def:name'),
      dataIndex: 'name',
      key: 'name'
    },
    {
      title: i.t('def:active'),
      dataIndex: 'enabled',
      key: 'enabled',
      render: (value: boolean | number) => value ? i.t('def:yes') : i.t('def:no')
    },
    {
      title: i.t('modifier:countable'),
      dataIndex: 'countable',
      key: 'countable',
      render: (value: boolean | number) => value ? i.t('def:yes') : i.t('def:no')
    },
    {
      title: i.t('def:price'),
      dataIndex: 'price',
      key: 'price'
    },
    {
      title: i.t('modifier:sorting'),
      dataIndex: 'sorting',
      key: 'sorting'
    },
    {
      title: i.t('def:actions.actions'),
      key: 'action',
      render: (list: any) => (
          <Space>
            <Tooltip title={i.t('def:actions.edit')} zIndex={5}>
              <Button
                  type="dashed"
                  shape="circle"
                  icon={<SettingOutlined />}
                  href={`/shop/modifiers/${list.id}`}
                  disabled={!canManageOwnedRecord(list)}
              />
            </Tooltip>

            <Tooltip title={i.t('def:actions.remove')} zIndex={5}>
              <Popconfirm
                  title={i.t('def:confirms.delete')}
                  onConfirm={() => ModifiersController.DeleteModifier(list.id)}
                  okText={i.t('def:yes')}
                  cancelText={i.t('def:no')}
                  disabled={!canManageOwnedRecord(list)}
              >
                <Button
                    type="dashed"
                    shape="circle"
                    icon={<DeleteOutlined />}
                    danger
                    disabled={!canManageOwnedRecord(list)}
                />
              </Popconfirm>
            </Tooltip>
          </Space>
      ),
    },
  ]

  return (
      <>
        <Titles
            title={i.t('nav:modifiers')}
            buttons={[
              { title: i.t('def:actions.create'), href: `/shop/modifiers/0`, type: 'dashed' },
            ]}
        />

        <Table
            rowKey="id"
            columns={columns}
            dataSource={ModifiersController.modifiers}
        />
      </>
  )
})